module.exports = __webpack_public_path__ + "img/SofF.e85c3c47.jpg";